import { Column, Row } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { MonthAvailableFromDateInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/MonthAvailableFromDateInput/MonthAvailableFromDateInput';
import { MonthAvailableToDateInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/MonthAvailableToDateInput';
import { AvailableOnSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/AvailableOnSelect/AvailableOnSelect';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';

export function MonthAvailabilityWrapper(): JSX.Element {
  const {
    isEditing,
    formValues: {
      isMonthAvailableWithinDateRange,
      isMonthAvailableOnSpecificDay,
    },
  } = useMealCreditFormData();

  return (
    <Row gutter={12}>
      <Column phone={3} gutter={12}>
        <AvailableOnSelect
          name="monthAvailableOn"
          id="monthAvailableOn"
          disabled={isEditing}
        />
      </Column>
      <Column phone={2} gutter={12}>
        <MonthAvailableFromDateInput
          id="monthAvailableFrom"
          name="monthAvailableFrom"
          disabled
        />
      </Column>
      {!isMonthAvailableOnSpecificDay && (
        <Column phone={2} gutter={12}>
          <MonthAvailableToDateInput
            id="monthAvailableTo"
            name="monthAvailableTo"
            disabled={isEditing || !isMonthAvailableWithinDateRange}
          />
        </Column>
      )}
    </Row>
  );
}
